import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import { NitroTabs, NitroBadge, NitroText } from "nitro-components";
import ComponentFactory from "../utils/ComponentFactory";

import ReactCSSTransitionGroup from "react-addons-css-transition-group";

const Container = styled.section`
  padding-top:15px;
  `;

const TabsContainer = styled.div`
  width: 60%;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const TabSection = styled.div`
height: 30px;
`;

const ContentContainer = styled.div`
display:flex;
flex-direction:column;
`;

const RowContainer = styled.div`
padding:0px 2px 0px 2px;
& >section{
  margin-bottom:20px;
}
& .background-enter {
  transform: translate(100%);
}
& .background-enter.background-enter-active {
  transform: translate(0%);
  transition: transform ${props => props.itr * 300}ms ease-in-out;
}
& .background-leave {
  transform: translate(0%);
}
.background-leave.background-leave-active {
  transform: translate(-100%);
  transition: transform ${props => props.itr * 300}ms ease-in-out;
}

& .background-appear {
  transform: translate(100%);
}

& .background-appear.background-appear-active {
  transform: translate(0%);
  transition: transform ${props => props.itr * 300}ms ease-in-out;
}
`;

const TabContentContainer = styled.div`
margin-top:25px;
`;

class TabsArray extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: [],
      selectedTab: {}
    };
  }

  componentDidMount() {
    if (this.props.data && this.props.data.length > 0) {
      let tabs = [];
      let selectedTab = {};

      for (const [index, record] of this.props.data.entries()) {
        if (index === 0)
          selectedTab = { displayLabel: record.name, key: record.key };
        tabs.push({
          displayLabel: record.name,
          key: record.key,
          content: (
            <TabSection>
              <NitroText size="14" bold>{record.name}</NitroText>
              <NitroBadge
                label={record.count}
                size={12}
                left={5}
                variant={
                  record.name === selectedTab.displayLabel
                    ? "secondary"
                    : "base2"
                }
              />
            </TabSection>
          )
        });
      }

      this.setState({
        tabs,
        selectedTab
      });
    }
  }

  handleTabChange = object => {
    //When ever the active tab is changed rerender the transformed tabs.
    const selectedTab = object;
    let tabs = [];
    for (const [index, record] of this.props.data.entries()) {
      tabs.push({
        displayLabel: record.name,
        key: record.key,
        content: (
          <TabSection>
            <NitroText size="14" bold>{record.name}</NitroText>
            <NitroBadge
              label={record.count}
              size={12}
              left={5}
              variant={
                record.name === selectedTab.displayLabel ? "secondary" : "base2"
              }
            />
          </TabSection>
        )
      });
    }

    this.setState({
      tabs,
      selectedTab
    });
  };

  renderTabContent = (key, data, onPanelClick) => {
    const content = data.filter(item => item.key === key)[0];
    return (
      <ContentContainer>
        {content.data.map(function(row, index) {
          return (
            <RowContainer key={index} itr={index+1}>
            <ReactCSSTransitionGroup
                transitionName="background"
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}
                transitionAppear={true}
                transitionAppearTimeout={0}
              >
              <ComponentFactory
                key={index}
                {...{
                  ...row,
                  onPanelClick
                }}
              />
              </ReactCSSTransitionGroup>
            </RowContainer>
          );
        })}
      </ContentContainer>
    );
  };

  render() {
    const { data } = this.props;
    const { tabs, selectedTab } = this.state;

    return (
      <Container>
        {selectedTab.key &&
          <div>
            <TabsContainer>
              <NitroTabs
                lineHeight={22}
                data={tabs}
                active={selectedTab.key}
                underline
                center
                action={this.handleTabChange}
              />
            </TabsContainer>
            <TabContentContainer>
              {this.renderTabContent(
                selectedTab.key,
                data,
                this.props.onRowClick
              )}
            </TabContentContainer>
          </div>}
      </Container>
    );
  }
}

TabsArray.propTypes = {
  // exampleProp: PropTypes.string.isRequired
  data: PropTypes.array,
  onRowClick: PropTypes.func
};

TabsArray.defaultProps = {
  // defaultProp: ''
};

export default TabsArray;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/TabsArray.js